import { useState } from "react";
import { SubpageShell } from "@/components/layout/SubpageShell";
import { Members } from "@/components/landing/Members";
import { ProfileDialog } from "@/components/landing/ProfileDialog";

export default function MembersPage() {
  const [selected, setSelected] = useState(null);
  return (
    <div data-testid="members-page">
      <SubpageShell titleZh="我们的伙伴" titleEn="Our Partners">
        <Members onSelect={setSelected} />
      </SubpageShell>
      <ProfileDialog person={selected} onClose={() => setSelected(null)} testidPrefix="member" linkBase="/members" />
    </div>
  );
}
